import React from "react";
import { Button } from 'react-materialize';
 
export default function BtnRequestCompensation() {
    return <Button node="button" id="btn-request-compensation">
        Request a compensation
    </Button>
}